import { render } from "./infoBlock.vue?vue&type=template&id=1dcf625a&scoped=true"
import script from "./infoBlock.vue?vue&type=script&lang=js"
export * from "./infoBlock.vue?vue&type=script&lang=js"

import "./infoBlock.vue?vue&type=style&index=0&id=1dcf625a&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcf625a"]])

export default __exports__